// Globals
import { useTranslation } from 'react-i18next';

// Permissions
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { getProductsTableColumns } from './columns';
import { Table } from '@/ui';

// Models
import { IProductVariation } from '@/models/products.model';

type TProductVariationsListProps = {
  productsVariations: IProductVariation[] | null;
  isLoading: boolean;
  handleDeleteVariation: (variation: IProductVariation) => void;
};

const ProductVariationsList = ({
  productsVariations,
  isLoading,
  handleDeleteVariation,
}: TProductVariationsListProps) => {
  const { t } = useTranslation(['products']);
  const { canManage } = usePermissions();
  const columns = getProductsTableColumns({
    t,
    handleDeleteVariation,
    canManage: canManage(Resource.PRODUCT),
  });

  return <Table columns={columns} dataSource={productsVariations || []} rowKey="id" loading={isLoading} />;
};

export default ProductVariationsList;
